import React from 'react';
import { FormField } from '@/components/custom/erp';
import { usePhuongThucThanhToan } from '@/hooks';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface EInvoiceTabProps {
  formMode: FormMode;
}

export default function EInvoiceTab({ formMode }: EInvoiceTabProps) {
  const { paymentMethods } = usePhuongThucThanhToan();

  return (
    <div className='p-4'>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Trạng thái HĐĐT</Label>
          <FormField
            name='ma_tthddt'
            type='select'
            className='min-w-44'
            options={[
              { value: '0', label: 'Không sử dụng' },
              { value: '1', label: 'Chờ phát hành' }
            ]}
            disabled={formMode === 'view'}
          />
        </div>

        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Thanh toán</Label>
          <FormField
            name='ma_pttt'
            type='select'
            className='min-w-44'
            options={paymentMethods.map(method => ({ value: method.uuid, label: method.ten_pttt }))}
            disabled={formMode === 'view'}
          />
        </div>

        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Số hóa đơn</Label>
          <FormField name='so_ct_hddt' type='text' disabled={formMode === 'view'} />
        </div>

        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Ngày hóa đơn</Label>
          <FormField name='ngay_ct_hddt' type='date' disabled={formMode === 'view'} className='w-44' />
        </div>

        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Ký hiệu</Label>
          <FormField name='so_ct2_hddt' type='text' disabled={formMode === 'view'} />
        </div>

        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Mẫu hóa đơn</Label>
          <FormField name='ma_mau_ct_hddt' type='text' disabled={formMode === 'view'} />
        </div>
      </div>
    </div>
  );
}
